import { SipMeetingRoomAssignment } from "../../model/sipMeetingRoomAssignment";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipMeetingRoomAssignment;

type fetchResponseType = {
  data?: DtoType;
  error?: string;
};

export type TransformedDataType = DtoType;

export type GuiResponseType = {
  data?: TransformedDataType;
  error?: string;
};

export async function getSipMeetingRoomAssignments(
  sipMeetingRoomAssignmentId: string
): Promise<GuiResponseType> {
  try {
    const url = apiUrls.getSipMeetingRoomAssignments.replace(
      "{{id}}",
      sipMeetingRoomAssignmentId
    );
    const response: fetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = response.data;

      console.log("API getSipMeetingRoomAssignments GUI: %o", xResponseData);
      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipMeetingRoomAssignments: %o", err);
    return { error: (err as Error).message };
  }
}
